import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-toggler',
  templateUrl: './toggler.component.html',
  styleUrls: ['./toggler.component.css']
})
export class TogglerComponent implements OnInit {
  @Input() mode: 'global' | 'rules' = 'global';
  @Input() changeMode: () => void = () => { };

  constructor(private translate: TranslateService) { }

  ngOnInit() {
    this.updateModeTexts();
    this.translate.onLangChange.subscribe(() => {
      this.updateModeTexts();
    });
  }

  private updateModeTexts() {
    const rulesModeText = this.translate.instant('Toggler.mode.rules');
    const globalModeText = this.translate.instant('Toggler.mode.global');

    document.documentElement.style.setProperty('--rules-mode-text', `"${rulesModeText}"`);
    document.documentElement.style.setProperty('--global-mode-text', `"${globalModeText}"`);
  }
} 